/**
 * Post-type registry for the composer.
 *
 * The composer is a generic shell (header + author row + body + footer).
 * Each "post type" is a self-contained module exported from this directory
 * and listed in the `postTypes` array below. The shell picks which type
 * is active based on a tab selector, then delegates body rendering,
 * validation, and submission to the active type's module.
 *
 * To add a new type (e.g. Spaces), write a new module implementing the
 * `PostTypePlugin` contract documented in README.md and import it here.
 * No shell changes required.
 */

import postType from './postType'
import classType from './classType'
import jobType from './jobType'
import spacesType from './spacesType'

const postTypes = [postType, classType, jobType, spacesType]

export default postTypes
